<template>
  <div>
    <b-card>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="productOrder.result"
      >
        <el-table-column
          label="Invoice ID"
          prop="pid"
          min-width="120px"
          v-slot="{ row }"
        >
          {{ row.invoiceId }}
        </el-table-column>
        <el-table-column
          label="Product Name"
          prop="pname"
          min-width="140px"
          v-slot="{ row }"
        >
          {{ row.product.name.slice(0, 50) }}...
        </el-table-column>
        <el-table-column
          label="Product Quantity"
          min-width="160px"
          prop="pquantity"
          v-slot="{ row }"
        >
          {{ row.product.quantity }}
        </el-table-column>
        <el-table-column
          label="Order Date"
          min-width="170px"
          prop="pquantity"
          v-slot="{ row }"
        >
          {{
            row.createdAt
              ? new Date(row.createdAt).toLocaleString("en-IN", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : ""
          }}
        </el-table-column>
        <el-table-column
          label="Name"
          min-width="160px"
          prop="name"
          v-slot="{ row }"
        >
          {{ row.deliveryDetails.fullName }}
        </el-table-column>
        <el-table-column
          label="Email"
          prop="email"
          min-width="180px"
          v-slot="{ row }"
        >
          {{ row.deliveryDetails.email }}
        </el-table-column>

        <el-table-column
          label="Contact No."
          prop="mobile"
          min-width="160px"
          v-slot="{ row }"
        >
          {{ row.deliveryDetails.phoneNumber }}
        </el-table-column>

        <el-table-column
          label="Shipping Address"
          prop="shippAdd"
          min-width="190px"
          v-slot="{ row }"
        >
          {{ row.deliveryDetails.address }}, {{ row.deliveryDetails.landMark }},
          {{ row.deliveryDetails.townCity }}
          ({{ row.deliveryDetails.pinCode }}),
          {{ row.deliveryDetails.state }}
        </el-table-column>

        <el-table-column
          label="Amount"
          prop="amount"
          min-width="150px"
          v-slot="{ row }"
        >
          {{ row.product.discountPrice }}
        </el-table-column>
        <el-table-column
          label="Status"
          prop="amount"
          min-width="150px"
          v-slot="{ row }"
        >
          {{ row.product.status }}
        </el-table-column>
        <el-table-column
          label="Tracking Id"
          prop="amount"
          min-width="150px"
          v-slot="{ row }"
        >
          {{
            row.product.shipmentNumber
              ? row.product.shipmentNumber
              : "Not Shipped Yet"
          }}
        </el-table-column>
      </el-table>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          @change="handlePageChange"
          :per-page="perPage"
          :total="total_row"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
// import projects from "../../../layouts/components/projects";
import { mapState } from "vuex";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      upcomingbooking: [],
      currentPage: 1,
      total_row: 1,
      perPage: 5,
    };
  },
  methods: {
    async init() {
      let loader = this.$loading();
      try {
        await this.$store.dispatch("affiliate/getVendorById", {
          userId: this.user._id,
        });
        let payload = {
          brandId: this.getVendor.vendor.brandId._id,
          status: "pending",
          limit: 5,
          offset: (this.currentPage - 1) * 5,
        };
        let data = await this.$store.dispatch(
          "affiliate/getBrandOrder",
          payload
        );
        this.total_row = this.productOrder.totalCount;
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async handlePageChange(value) {
      this.currentPage = value;
      try {
        this.init();
      } catch (error) {}
    },
    async handleStatus(status, id) {},
  },
  computed: {
    ...mapState("auth", { user: "user" }),

    ...mapState("affiliate", {
      productOrder: "productOrder",
    }),
    ...mapState("affiliate", {
      brandData: "brandData",
      getVendor: "getVendor",
    }),
  },
  mounted() {
    this.init();
  },
};
</script>
